module.exports = __webpack_public_path__ + "img/ss1.5771e3c3.png";